import React from 'react'
import styles from './index.module.css'
import pointer from './pointer.svg'

const NavigationStep = ({ step, showSwipeHint }) => (
  <div className={styles.step}>
    {step.imageUrl && (
      <div className={styles.step_image_wrap}>
        <img
          src={step.imageUrl}
          alt={step.title}
          className={styles.step_image}
          draggable="false"
        />
        {showSwipeHint && (
          <div className={styles.image_swipe_hint} aria-hidden="true">
            <img
              className={styles.swipe_icon}
              src={pointer}
              alt=""
              aria-hidden="true"
            />
          </div>
        )}
      </div>
    )}
    <div className={styles.step_body}>
      <h3 className={styles.step_title}>{step.title}</h3>
      <p className={styles.step_description}>{step.description}</p>
    </div>
  </div>
)

export default NavigationStep
